import { createInspectToolbar } from "./inspect-toolbar";
import { computeObjectAABB } from "./auto-box-collider";
import { setMatrixWorld } from "./three-utils";
import { Layers } from "../camera-layers";

// A world-sized toolbar, positioned below the model in the Inspect pivot's orientation.
export function getObjectInspectToolbarPlacement(inspectable, pivot) {
  pivot.updateWorldMatrix(true, true);
  const position = new THREE.Vector3();
  const rotation = new THREE.Quaternion();
  pivot.matrixWorld.decompose(position, rotation, new THREE.Vector3());
  const frame = new THREE.Matrix4().compose(position, rotation, new THREE.Vector3(1, 1, 1));
  const mesh = inspectable.el.getObject3D("mesh") || inspectable;
  const box = computeObjectAABB(mesh, new THREE.Box3(), true).applyMatrix4(frame.clone().invert());
  if (box.isEmpty()) box.set(new THREE.Vector3(-0.3, -0.3, -0.3), new THREE.Vector3(0.3, 0.3, 0.3));
  const center = box.getCenter(new THREE.Vector3());
  center.y = box.min.y - 0.18;
  center.z = box.max.z + 0.02;
  return { position: center.applyMatrix4(frame), rotation };
}

export function createObjectInspectControls(scene, cameraSystem) {
  const target = cameraSystem.inspectable;
  if (!(scene.is("vr-mode") || scene.is("ar-mode")) || target.el.querySelector("[artwork-info]")) return null;
  const placement = getObjectInspectToolbarPlacement(target, cameraSystem.pivot);
  const controls = createInspectToolbar({
    isActive: () => cameraSystem.inspectable === target && controls.el.object3D.visible,
    onToggle: () => cameraSystem.toggleLights(),
    onClose: () => {
      scene.emit("uninspect");
      cameraSystem.uninspect();
    }
  });
  controls.target = target;
  scene.appendChild(controls.el);
  const matrix = new THREE.Matrix4();
  const rotation = placement.rotation.clone();
  const toolbarScale = new THREE.Vector3(0.75, 0.75, 0.75);
  controls.updatePose = (faceCamera = true) => {
    controls.el.object3D.visible = cameraSystem.inspectable === target && (scene.is("vr-mode") || scene.is("ar-mode"));
    if (faceCamera) cameraSystem.viewingCamera.getWorldQuaternion(rotation);
    setMatrixWorld(controls.el.object3D, matrix.compose(placement.position, rotation, toolbarScale));
    // A-Frame can add button meshes after creation; keep those on the Inspect layer too.
    controls.el.object3D.traverse(object => object.layers.enable(Layers.CAMERA_LAYER_INSPECT));
    controls.update(cameraSystem.lightsEnabled);
  };
  controls.getBounds = () => {
    controls.el.object3D.updateWorldMatrix(true, true);
    return new THREE.Box3(new THREE.Vector3(-0.24, -0.17, -0.02), new THREE.Vector3(0.24, 0.09, 0.02)).applyMatrix4(
      controls.el.object3D.matrixWorld
    );
  };
  controls.updatePose(false);
  return controls;
}
